
<script>
	import {onDestroy, onMount} from 'svelte';
	import RightBlockButton from './../components/RightBlockButton.svelte';

	export let bot;

    onMount(() => {
		jQuery( ".right-block-ul" ).sortable({
            stop: function( event, ui ) {
                document.querySelectorAll(".right-block-li").forEach((e, idx) => {
                    const id = e.dataset.id;
                    bot.defaultChar.changeRightButtonSeq(id, idx);
                });
            }
        });
    });
</script>
<div class="right-block-wrapper">
	<ul class="right-block-ul">
	{#each bot.defaultChar.rightButtonList as button}
	<li class="right-block-li" data-id={button.id}>
		<RightBlockButton {bot} {button}/>
	</li>
	{/each}
	<a href="#" class="add-content w-button" on:click={()=>bot.defaultChar.addRightButton("LINK")}>링크버튼 추가하기</a>
</ul>
</div>
<style>

	.right-block-ul {
        list-style-type: none;
        padding-left: 0px;
    }

	.right-block-wrapper {
		width: 420px;
	}
	.add-content {
		width: 420px;
	}
</style>